import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer,
} from "recharts";

export default function UserGrowthBarChart({ rawGrowth, selectedYear }) {
    // Get theme colors from CSS variables
    const getThemeColor = (variable) => {
        if (typeof window !== 'undefined') {
            return getComputedStyle(document.documentElement)
                .getPropertyValue(variable)
                .trim() || '#06b6d4';
        }
        return '#06b6d4';
    };

    const primaryColor = getThemeColor('--primary-solid') || '#22d3ee';
    const textColor = getThemeColor('--text-secondary') || '#bae6fd';
    const gridColor = 'rgba(56, 189, 248, 0.15)';

    // Use selectedYear instead of current year
    const fullGrowth = Array.from({ length: 12 }).map((_, index) => {
        const monthName = new Date(selectedYear, index).toLocaleDateString("en-US", {
            month: "short",
        });

        return {
            month: monthName,
            count: 0,
        };
    });

    // Map API data correctly
    rawGrowth.forEach((item) => {
        const monthIndex = item.month - 1;
        if (fullGrowth[monthIndex]) {
            fullGrowth[monthIndex].count = item.count;
        }
    });

    return (
        <div className="w-full overflow-x-auto">
            <div className="min-w-[600px] h-72">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={fullGrowth} margin={{ top: 10, right: 12, left: -10, bottom: 0 }}>
                        <defs>
                            <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#22d3ee" stopOpacity={1} />
                                <stop offset="100%" stopColor="#2563eb" stopOpacity={0.85} />
                            </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" stroke={gridColor} vertical={false} />
                        <XAxis 
                            dataKey="month" 
                            stroke={textColor} 
                            style={{ fontSize: '12px' }}
                            tickLine={false}
                            axisLine={{ stroke: gridColor }}
                        />
                        <YAxis 
                            stroke={textColor} 
                            style={{ fontSize: '12px' }}
                            tickLine={false}
                            axisLine={false}
                        />
                        <Tooltip
                            cursor={{ fill: 'rgba(6, 182, 212, 0.08)' }}
                            contentStyle={{
                                background: "rgba(4, 18, 48, 0.88)",
                                backdropFilter: "blur(14px)",
                                border: "1px solid rgba(56, 189, 248, 0.35)",
                                borderRadius: "16px",
                                color: "#f0f9ff",
                                boxShadow: "0 16px 40px rgba(0, 3, 15, 0.7)",
                            }}
                            labelStyle={{ 
                                color: "#38bdf8",
                                fontWeight: "700",
                                marginBottom: "4px",
                            }}
                            itemStyle={{ color: "#f0f9ff", fontWeight: 600 }}
                        />
                        <Bar
                            dataKey="count"
                            fill="url(#barGradient)"
                            barSize={32}
                            radius={[8, 8, 0, 0]}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}